// extracted by mini-css-extract-plugin
export default {"createDialog":"Payments_createDialog__vwbfJ","loader":"Payments_loader__EqIeh"};